import gql from 'graphql-tag'
import client from '../../stores/apollo'
import { sortBy } from 'lodash'
import { BMTableBuildingFragment } from '@api/fragments'
import { IBuildingsConnectionWithTotal } from '@api/types'

interface Payload {
  data: {
    viewer: {
      company: {
        buildingsConnection: IBuildingsConnectionWithTotal
      }
    }
  }
}

export interface IBuildingVariables {
  first?: number
  orderBy: string
  after?: string | null
  where?: any
}

export default function list(
  variables: IBuildingVariables
): Promise<IBuildingsConnectionWithTotal> {
  return client.gql
    .query({
      query: buildingsQuery,
      variables: variables,
    })
    .then(
      ({
        data: {
          viewer: {
            company: { buildingsConnection },
          },
        },
      }: Payload) => {
        for (const edge of buildingsConnection.edges)
          edge.node.floors = sortBy(edge.node.floors, 'story')
        return buildingsConnection
      }
    )
}

export const buildingsQuery = gql`
  query buildings(
    $after: String
    $orderBy: BuildingOrderByEnum
    $first: Int
    $where: BuildingWhereInput
  ) {
    viewer {
      company {
        buildingsConnection(after: $after, orderBy: $orderBy, first: $first, where: $where) {
          counters {
            total
          }
          pageInfo {
            endCursor
            hasNextPage
          }
          edges {
            node {
              ...BMTableBuildingFragment
            }
          }
        }
      }
    }
  }
  ${BMTableBuildingFragment}
`
